import { useStats } from '../contexts/StatsContext'

export default function NetworkIndicator() {
  const { stats } = useStats()
  const block = stats?.block

  const formatNumber = (n: number) => n.toLocaleString()

  return (
    <div className="flex items-center gap-2">
      <span className="text-xs font-mono text-slate-500">
        {block ? formatNumber(block.number) : '...'}
      </span>
      <span className={`h-2 w-2 rounded-full ${block ? 'bg-green-500' : 'bg-slate-600'}`} />
    </div>
  )
}

